import React from "react";

const ParticlesBackground: React.FC = () => {
  return (
    <div
      className="fixed inset-0 -z-10"
      style={{
        background: `
          radial-gradient(circle at 20% 50%, rgba(59, 130, 246, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 40% 80%, rgba(239, 68, 68, 0.1) 0%, transparent 50%),
          radial-gradient(circle at 0% 100%, rgba(245, 158, 11, 0.1) 0%, transparent 50%)
        `,
      }}
    />
  );
};

export default ParticlesBackground;
